import { useTranslation } from '@wix/fe-essentials/i18n';
import { useCallback } from 'react';
import { BiModalTypes } from '../../../bi/types';
import { useA11yWizardAdapter } from '../../../hooks/use-a11y-wizard-adapter';
import { useBiLogger } from '../../../hooks/use-bi-logger';
import { PanoramaErrorNames, PanoramaTransactions } from '../../../panorama/constants';
import { usePanoramaFunctions } from '../../../panorama/use-panorama-functions';
import { showDomOrderErrorModal } from './show-dom-order-error-modal';
import { useDomOrderFix } from './use-dom-order-fix';
import { DOM_ORDER_FIX_OPTION } from './use-dom-order-rule';
let isInProgress = false;
const handleBeforeUnload = event => {
  if (isInProgress) {
    event.preventDefault();
  }
  return '';
};
export const useReorganizePagesDOMOrder = () => {
  const biLogger = useBiLogger();
  const {
    a11yWizardAdapter,
    editorHost
  } = useA11yWizardAdapter();
  const {
    t
  } = useTranslation();
  const {
    handleAutoFix,
    handleManualFix
  } = useDomOrderFix();
  const {
    reportErrorPanorama,
    finishPanoramaTransaction,
    startPanoramaTransaction
  } = usePanoramaFunctions();
  const reorganizePagesDOMOrder = useCallback(async _ref => {
    let {
      fixOption,
      isManuallyCompleted,
      handleTryAgain,
      handleCancel,
      screenType
    } = _ref;
    let isError = false;
    const progressBarHandler = {
      closeProgressBar: () => {}
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    try {
      startPanoramaTransaction(PanoramaTransactions.reorganizePagesDOMOrder, {
        fixOption,
        isManuallyCompleted,
        screenType
      });
      biLogger.modalView({
        modalType: BiModalTypes.PreparingSiteForScan
      });
      isInProgress = true;
      if (fixOption.value === DOM_ORDER_FIX_OPTION.AUTO) {
        await handleAutoFix({
          progressBarHandler,
          screenType
        });
      } else {
        await handleManualFix({
          isManuallyCompleted,
          screenType
        });
      }
    } catch (error) {
      isError = true;
      biLogger.modalClose({
        modalType: BiModalTypes.PreparingSiteForScan
      });
      reportErrorPanorama(error, PanoramaErrorNames.reorganizePagesDOMOrder);
      progressBarHandler.closeProgressBar();
      biLogger.modalView({
        modalType: BiModalTypes.UnableToOrganizeDOMOrder
      });
      showDomOrderErrorModal({
        a11yWizardAdapter,
        editorHost,
        fixOption,
        handleCancel,
        handleTryAgain,
        t
      });
      throw new Error('Error reorganizing DOM order', {
        cause: error
      });
    } finally {
      isInProgress = false;
      window.removeEventListener('beforeunload', handleBeforeUnload);
      if (!isError) {
        finishPanoramaTransaction(PanoramaTransactions.reorganizePagesDOMOrder, {
          fixOption,
          isManuallyCompleted,
          screenType
        });
      }
    }
  }, [startPanoramaTransaction, biLogger, handleAutoFix, handleManualFix, reportErrorPanorama, a11yWizardAdapter, editorHost, t, finishPanoramaTransaction]);
  return {
    reorganizePagesDOMOrder
  };
};
//# sourceMappingURL=use-reorganize-pages-dom-order.js.map